/* eslint-disable implicit-arrow-linebreak */
export const requiredRule = (v) => !!v || 'This field is required'
export const emailRule = (v) =>
	!v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
export const numberRule = (v) => !v || /^\d+$/.test(v) || 'This field only accepts numbers'
export const mobileNoRule = (v) =>
	!v || /^[0-9]{9,13}$/.test(v) || 'Mobile no can only have min 9 and max 13 numbers'

export default undefined
